import { InternalAxiosRequestConfig } from 'axios'

export const requestTokenInterceptor = (config: InternalAxiosRequestConfig): InternalAxiosRequestConfig => {
  if (!config.withCredentials) {
    return {
      ...config,
      headers: {
        ...config.headers
      }
    } as unknown as InternalAxiosRequestConfig
  }

  return config
}
